import React, { createContext, useContext } from "react";

import { useInlineMerchCard } from "../hooks/use-inline-merch-card";
import { CardPlaceholder } from "./card-placeholder";

const CardContext = createContext({} as ReturnType<typeof useInlineMerchCard>);

export const useCardContext = () => useContext(CardContext);

type ProviderProps = {
  handle: string;
  children: React.ReactNode;
};

export function CardProvider({ handle, children }: ProviderProps) {
  const value = useInlineMerchCard(handle);

  if (!value || value.loading) return <CardPlaceholder />;
  return <CardContext.Provider value={value}>{children}</CardContext.Provider>;
}
